import React from 'react'
import { Link } from 'react-router-dom'
import Icons from '../myIcon/Icons'

export default function DefaultLink({to, text="know more", onClick}) {
  return (
    <>
      <Link onClick={onClick} className="default-link" to={to}>{text} <Icons name={"Longarrow_right"}/></Link>
    </>
  )
}
